<template>
    <van-popup class="my-vip-suc-pop-box" position="center" :value="showVipSucPop" @click-overlay="clickClose">
        <div class="my-vip-suc-pop">
            <!-- <div class="my-vip-suc-title"></div> -->
            <div class="my-vip-suc-content">
                <div class="my-vip-suc-avatar" v-if="!fromEmbedded && userData && userData.info">
                    <img class="my-vip-suc-img" v-bind:src="userData.info.avatar" alt="">
                    <div class="my-vip-suc-vip"></div>
                    <div class="my-vip-suc-crown"></div>
                </div>
                <div class="my-vip-suc-avatar" v-if="fromEmbedded && userUid">
                    <img class="my-vip-suc-img" v-bind:src="UTILS.getAvatarUrlByUid(userUid)" alt="">
                    <div class="my-vip-suc-vip"></div>
                    <div class="my-vip-suc-crown"></div>
                </div>
            </div>
            <div class="my-vip-suc-text">
                <p>感谢您的大力支持，</p>
                <p>已为您点亮会员头像及标识！</p>
                <p>更多会员特权敬请关注。</p>
            </div>
        </div>
    </van-popup>
</template>

<script>
import { UTILS } from '../../modules/utils'
export default {
    name: 'VantVipSucPop',
    computed: {
        showVipSucPop() {
            return this.$store.state.user.showVipSucPop;
        },
        userData() {
            return this.$store.state.userData;
        },
        fromEmbedded() {
            return this.$store.state.embedded.fromEmbedded;
        },
        userUid() {
            return this.$store.state.embedded.userUid;
        }
    },
    data() {
        return {
            UTILS: UTILS
        }
    },
    methods: {
        clickClose() {
            this.$store.state.user.showVipSucPop = false;
        }
    }
}
</script>